export default "__VITE_ASSET__YgjFhTH8__"